import { enumToOptions } from '@app/shared/helpers';
import { YesNoOptions } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getYesNoOptions = () =>
  enumToOptions(YesNoOptions, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    value: o.value,
  }));
